import React, { Fragment, useEffect, useState } from "react";
import { TabPane, TabContent } from "reactstrap";
import classnames from 'classnames';

import DragonHitContest from "./DragonHitContest";
import User             from "~/services/user";
import NinjaHikeContest from "./NinjaHikeContest";
import DragonHitLogo    from "~/assets/images/tournament/dragon-hit.png";
import NinjaHikeLogo    from "~/assets/images/tournament/NinjaHike-logo.png";

const ContestsPage = ({})=> {

  const [user, setUser] = useState();
  const [tab , setTab ] = useState('dragon');

  useEffect(()=> {
    (async ()=> setUser(await User.account()))();
  }, []);

  if(!user) return null;

  return (
    <Fragment>
      <h4 className="text-center m-b-30"> How to win big bonuses everyday?</h4>

      <div className="tab-switcher m-15">
        <p className={classnames({"selected": tab == 'dragon' })} onClick={()=> setTab('dragon')  }> <img src={DragonHitLogo} width={25}/> <span>Dragon Hit</span>  </p>
        <p className={classnames({"selected": tab == 'ninja' })} onClick={()=> setTab('ninja') }> <img src={NinjaHikeLogo} style={{borderRadius: "5px"}} width={25}/> <span>Ninja Hike </span> </p>
      </div>
      <TabContent activeTab={tab} className="m-t-40">

        <TabPane tabId="dragon" className="fade show"> <DragonHitContest user={user} /> </TabPane>
        <TabPane tabId="ninja"> <NinjaHikeContest user={user} /> </TabPane>

      </TabContent>
    </Fragment>
  ); 
}

export default ContestsPage;
